// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSFinance = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/horas_extras_01.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_02.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_03.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_04.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_05.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_06.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_07.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_08.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_09.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/horas_extras_10.jpeg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Finance</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tls.horasextras"}
				apple_store={""}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Gerencie suas horas extras e banco de horas de forma simples, rápida e totalmente visual.<br />
										Este aplicativo foi desenvolvido para facilitar o controle da sua jornada de trabalho, permitindo registrar entradas, saídas, horas extras, compensações e acompanhar seu saldo atualizado em tempo real.
										<br />
										<br />
										Com uma interface intuitiva e prática, você pode armazenar todos os seus registros com segurança, visualizar resumos detalhados por período e acompanhar a evolução do seu banco de horas sem complicações.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Cálculo Automático:</strong> Cálculo automático de horas extras e saldo atualizado.</li>
											<li><strong>Controle Completo:</strong> Gerencie entradas, saídas e compensações com precisão.</li>
											<li><strong>Visualização Organizada:</strong> Acompanhe resumos detalhados por período.</li>
											<li><strong>Armazenamento Seguro:</strong> Seus dados protegidos e sempre acessíveis.</li>
											<li><strong>Exportação de Relatórios:</strong> Gere relatórios completos para conferência ou envio ao RH.</li>
										</ul>
										<br />
										Tenha controle total da sua carga horária, evite erros manuais e acompanhe seu banco de horas com transparência e eficiência.
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										Gestiona tus horas extra y banco de horas de forma simple, rápida y totalmente visual.<br />
										Esta aplicación fue desarrollada para facilitar el control de tu jornada laboral, permitiendo registrar entradas, salidas, horas extra, compensaciones y seguir tu saldo actualizado en tiempo real.
										<br />
										<br />
										Con una interfaz intuitiva y práctica, puedes almacenar todos tus registros de forma segura, visualizar resúmenes detallados por período y seguir la evolución de tu banco de horas sin complicaciones.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Cálculo Automático:</strong> Cálculo automático de horas extra y saldo actualizado.</li>
											<li><strong>Control Completo:</strong> Gestiona entradas, salidas y compensaciones con precisión.</li>
											<li><strong>Visualización Organizada:</strong> Consulta resúmenes detallados por período.</li>
											<li><strong>Almacenamiento Seguro:</strong> Tus datos protegidos y siempre accesibles.</li>
											<li><strong>Exportación de Informes:</strong> Genera informes completos para revisión o envío al área de RRHH.</li>
										</ul>
										<br />
										Mantén el control total de tu carga horaria, evita errores manuales y gestiona tu banco de horas con transparencia y eficiencia.
									</div>
								)
								:
								(
									<div className='term_just'>
										Manage your overtime and time bank in a simple, fast, and fully visual way.<br />
										This app was developed to simplify work schedule tracking, allowing you to record clock-ins, clock-outs, overtime, compensations, and monitor your updated balance in real time.
										<br />
										<br />
										With an intuitive and practical interface, you can securely store all records, view detailed summaries by period, and track your time bank evolution without complications.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Automatic Calculation:</strong> Automatic overtime and balance calculation.</li>
											<li><strong>Complete Control:</strong> Manage clock-ins, clock-outs, and compensations accurately.</li>
											<li><strong>Organized View:</strong> Access detailed summaries by period.</li>
											<li><strong>Secure Storage:</strong> Your data protected and always accessible.</li>
											<li><strong>Report Export:</strong> Generate complete reports for personal review or HR submission.</li>
										</ul>
										<br />
										Take full control of your working hours, avoid manual errors, and manage your time bank with transparency and efficiency.
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSFinance;